import { Flex, Tag, Typography } from 'antd'
import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import type { OutboundWebhookRead } from 'src/api/main'

import { isSquadManaged } from './utils'

const { Link, Text } = Typography

type Props = {
  webhook: OutboundWebhookRead
  squadAgentUrl: string | null
}

export const WebhookName = ({ webhook, squadAgentUrl }: Props) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={2} align="flex-start" style={{ minWidth: 0 }}>
      <Flex align="center" gap={6} style={{ minWidth: 0, maxWidth: '100%' }}>
        {webhook.name ? (
          <Text strong ellipsis>
            {webhook.name}
          </Text>
        ) : (
          <Text type="secondary">—</Text>
        )}
        {isSquadManaged(webhook) && (
          <Tag color="purple" style={{ marginInlineEnd: 0 }}>
            {t('workspace.apps.outboundWebhooks.managed.tag', 'Squad')}
          </Tag>
        )}
      </Flex>
      {squadAgentUrl && (
        <Link
          href={squadAgentUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 12 }}
        >
          <Flex align="center" gap={4} component="span">
            {t(
              'workspace.apps.outboundWebhooks.managed.openInSquad',
              'Open in Squad'
            )}
            <ExternalLink size={12} />
          </Flex>
        </Link>
      )}
    </Flex>
  )
}
